import { ActionType } from '@gearbelt/global';
import { match } from 'ts-pattern';

export function actionTypeLabel(type: ActionType): string {
  return match(type)
    .with(ActionType.IssueCreated, () => 'Issue Created')
    .with(ActionType.IssueEdited, () => 'Issue Edited')
    .with(ActionType.IssueArchived, () => 'Issue Archived')
    .with(ActionType.IssueRestored, () => 'Issue Restored')
    .with(ActionType.IssueDeleted, () => 'Issue Deleted')
    .with(ActionType.IssueClosed, () => 'Issue Closed')
    .with(ActionType.IssueReopened, () => 'Issue Reopened')
    .with(ActionType.RepairRecordSubmitted, () => 'Repair Record Created')
    .with(ActionType.RepairRecordEdited, () => 'Repair Record Edited')
    .with(ActionType.WorkOrderCreated, () => 'Work Order Created')
    .with(ActionType.WorkOrderEdited, () => 'Work Order Edited')
    .with(ActionType.WorkOrderClosed, () => 'Work Order Closed')
    .with(ActionType.WorkOrderReopened, () => 'Work Order Reopened')
    .with(ActionType.WorkOrderArchived, () => 'Work Order Archived')
    .with(ActionType.WorkOrderRestored, () => 'Work Order Restored')
    .with(ActionType.WorkOrderDeleted, () => 'Work Order Deleted')
    .with(ActionType.WorkOrderLinked, () => 'Work Order Linked')
    .with(ActionType.WorkOrderUnlinked, () => 'Work Order Unlinked')
    .with(ActionType.ScheduleFormRecordSubmitted, () => 'Schedule Form Record Submitted')
    .with(ActionType.ScheduleFormRecordEdited, () => 'Schedule Form Record Edited')
    .with(ActionType.CheckClosed, () => 'Schedule Check Closed')
    .with(ActionType.FormTemplateCreated, () => 'Form Template Created')
    .with(ActionType.FormTemplateEdited, () => 'Form Template Edited')
    .with(ActionType.FormTemplateArchived, () => 'Form Template Archived')
    .with(ActionType.FormTemplateRestored, () => 'Form Template Restored')
    .with(ActionType.FormTemplateDeleted, () => 'Form Template Deleted')
    .exhaustive();
}
